import { apiSlice } from '../apiSlice';

export const shuttleAPI = apiSlice
  .enhanceEndpoints({ addTagTypes: ['shuttle'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getCampusSetting: build.query({
        query: (campusCode: string) => ({
          url: `/mgmt/campuses/setting/${campusCode}`,
          method: 'GET',
        })
      }),
    }),
  });

export const {
  useGetCampusSettingQuery
}: any = shuttleAPI;
